// extracted by mini-css-extract-plugin
export default {"app-loader":"App_app-loader__nE-6I","app-notification-container":"App_app-notification-container__U9D6b"};